import { render, staticRenderFns } from "./deleteOweFeeCallable.vue?vue&type=template&id=5648d68a"
import script from "./deleteOweFeeCallable.vue?vue&type=script&lang=js"
export * from "./deleteOweFeeCallable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports